import { SmsCharacterLimit } from '../useCharacterCounter.types';

/**
 * The gsm-7 character set. See
 * https://en.wikipedia.org/w/index.php?title=GSM_03.38&oldid=972147851#GSM_7-bit_default_alphabet_and_extension_table_of_3GPP_TS_23.038_/_GSM_03.38
 *
 * Note that the last character is a non-breaking space the editor uses for
 * spaces at the ends of a text. For example `foo ` is `foo&nbsp;` whereas `foo
 * bar` is with an actual space character.
 */
const gsm7 = `A-Za-z0-9 \\r\\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!"#$%&amp;'()*+,\\-./:;&lt;=&gt;?¡ÄÖÑÜ§¿äöñüà\u00A0`;

/** The gsm-7 extended character set. */
const gsm7Extended = `\\^{}\\\\\\[~\\]|\u20AC`;

/** The gsm-7 regex. */
export const gsm7Regex = RegExp(`^[${gsm7}]*$`);

/** The gsm-7 extended regex. */
export const gsm7ExtendedRegex = RegExp(`^[$${gsm7}${gsm7Extended}]*$`);

/** The gsm-7 extended only regex. */
export const gsm7ExtendedOnlyRegex = RegExp(`^[${gsm7Extended}]*$`);

/** The message limits for sms messages. */
export const smsMessageLimits: SmsCharacterLimit = {
  'GSM-7': { single: 160, multiple: 153 },
  'GSM-7-EXTENDED': { single: 160, multiple: 153 },
  'UTF-16': { single: 70, multiple: 67 },
};
